import { getApi } from '../../components/Shared/shared';

const baseURL = getApi();

export const areaUrls = {
  areas: `${baseURL}/areas`
};

export default areaUrls;
